import { Trait } from '../../trait.type';
import { TraitRegistry, TraitType } from '../../trait-registry';
import type { Technique } from '../../techniques.type';
import { healthRemove, type Player } from '../../player.type';
import { StatusEffect } from '../../status-effects.type';
import type { Die } from '../../die.type';

export class KrakenTrait extends Trait {
  static baseType = TraitType.Kraken;
  static baseTitle = 'Kraken Grasp';
  static baseText =
    'When using an attack, if the target is grappled deal 1 pure damage per die used.';
  static baseIcon = 'trait';

  type = KrakenTrait.baseType;
  title = KrakenTrait.baseTitle;
  text = KrakenTrait.baseText;
  icon = KrakenTrait.baseIcon;

  useTechnique(technique: Technique, target: Player, source: Player, die: Array<Die>): void {
    if (technique.tags.includes('damage') === false) {
      return;
    }
    if (target.statusEffects.some((modifier) => modifier.type === StatusEffect.Grappled)) {
      healthRemove({ value: die.length, target, source, dice: [] });
    }
  }
}

TraitRegistry.register(KrakenTrait.baseType, KrakenTrait);
